'use client';
import { useRouter } from 'next/router';
import { matchParamsAndLink } from '@careos/utils';
import OpenCardIcon from '@public/icons/icon-open-card.png';
import FloatingIcon from 'components/common/FloatingIcon';
import { hsbcLink } from 'lib/constants';
import { useScrollVisibility } from 'hooks/useScrollVisibility';

interface FloatingWidgetProps {
  locale?: string;
}

function FloatingWidget({ locale }: Readonly<FloatingWidgetProps>) {
  const isVisible = useScrollVisibility();
  const { query } = useRouter();
  if (locale !== 'vi') return null;
  const concatRccidOnly = Object.keys(query).length === 0;
  const redirectLink = matchParamsAndLink(
    true,
    hsbcLink,
    query,
    concatRccidOnly
  );

  return (
    <FloatingIcon
      isVisible={isVisible}
      link={redirectLink}
      icon={OpenCardIcon?.src}
      dataTestId="open-card-widget-container"
      alt="open-card-icon"
    />
  );
}

export default FloatingWidget;
